<template>
  <div>
    <div class="clearfix">
      <div class="float-right">
        <em class="text-info" v-text="`Page: ${pagination.page}`" />
        <b-form-select
          class="w-auto ml-2"
          variant="primary"
          v-model="pagination.limit"
          :options="pagination.pageOptions"
          @change="setPage(1)"
        ></b-form-select>

        <b-button-group>
          <b-button
            variant="primary"
            class="mr-1"
            v-text="'<<'"
            :disabled="loading || pagination.page == 1"
            @click="setPage(1)"
          />
          <b-button
            variant="primary"
            class="mr-1"
            v-text="'<'"
            :disabled="loading || pagination.page == 1"
            @click="previousPage()"
          />
          <b-button
            variant="primary"
            class="mr-1"
            v-text="'>'"
            :disabled="
              loading || (historyLog && historyLog.length < pagination.limit)
            "
            @click="nextPage()"
          />
        </b-button-group>
      </div>
    </div>

    <common-loading :message="$t('commons.fetching_history')" v-if="loading" />

    <div class="clearfix" v-if="!loading">
      <div class="alert alert-warning" v-if="isHistoryEmpty">
        <i class="fa fa-warning"></i> No History Found!
      </div>

      <hr />

      <div class="feed-activity-list">
        <div
          class="feed-element"
          v-for="(history, index) in historyLog"
          :key="index"
        >
          <div class="media-body">
            <strong>
              #{{ history.id }} History Log
              <small class="float-right">{{ history.createTime }}</small>
            </strong>
            <p>
              <strong>Modified By:</strong>
              {{ history.modifiedBy }}
            </p>

            <b-table
              striped
              hover
              bordered
              show-empty
              fixed
              thead-class="table-dark"
              :items="history.changelog"
              :fields="fields"
              :busy="loading"
              class="mt-2"
            ></b-table>
          </div>

          <hr />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: String | Number,
    instanceId: {
      type: String | Number,
      default: null,
    },
    callback: Function
  },
  created() {
    this.fetchHistory();
  },
  data() {
    return {
      historyLog: [],
      loading: false,
      errorMessage: null,
      pagination: {
        page: 1,
        limit: 10,
        pageOptions: [10, 25, 50, 100],
      },
      fields: [
        {
          key: "op",
          label: this.$t("commons.action"),
          class: "font-weight-bold",
        },
        {
          key: "path",
          label: this.$t("commons.path"),
          class: "font-weight-bold",
        },
        {
          key: "oldValue",
          label: this.$t("commons.old_value"),
        },
        {
          key: "value",
          label: this.$t("commons.new_value"),
        },
      ],
    };
  },
  computed: {
    isHistoryEmpty() {
      return this.historyLog && this.historyLog.length == 0;
    },
  },
  methods: {
    fetchHistory() {
      this.loading = true;
      this.errorMessage = null;
      let params = {
        history: true,
        limit: this.pagination.limit,
        offset: (this.pagination.page - 1) * this.pagination.limit,
      };

      let methodArgs = this.instanceId
        ? [this.id, this.instanceId, params]
        : [this.id, params];
      this.callback
        .apply(this, methodArgs)
        .then((r) => {
          this.loading = false;
          this.historyLog = r.data.result.history || [];
        })
        .catch((e) => {
          this.errorMessage = this.$t("commons.history_failed");
          this.$toast.error("Error", this.errorMessage);
        });
    },
    nextPage() {
      this.setPage(this.pagination.page + 1);
    },
    previousPage() {
      this.setPage(this.pagination.page - 1);
    },
    setPage(page) {
      this.pagination.page = page;
      this.fetchHistory();
    },
  },
};
</script>
